/**
 * Israeli ID (תעודת זהות) validation.
 * 9 digits; 9th digit is a Luhn-style check digit (positions 2,4,6,8 × 2, then sum mod 10).
 */
export function isValidIsraeliId(id: string): boolean {
  const trimmed = id.trim().replace(/\s/g, "");
  if (!/^\d{9}$/.test(trimmed)) return false;
  let sum = 0;
  for (let i = 0; i < 8; i++) {
    let digit = parseInt(trimmed[i], 10);
    if (i % 2 === 1) {
      digit *= 2;
      if (digit >= 10) digit = 1 + (digit % 10);
    }
    sum += digit;
  }
  return (sum + parseInt(trimmed[8], 10)) % 10 === 0;
}
